export default __webpack_public_path__ + "static/media/WhatsApp_Image_2025-10-21_at_10.25.51_PM-removebg-preview.d7a85821.png";